import React from 'react';
import { FilterOptionKeys } from '@mybestbrands/types';
import FilterToggle, { FilterToggleType } from '@/app/ui/components/filters/FilterToggle';

const HottestSaleFilter = ({
  isActive,
  type = FilterToggleType.BUTTON,
}: {
  isActive: boolean;
  type?: FilterToggleType;
}) => {
  return <FilterToggle isActive={isActive} filterKey={FilterOptionKeys.HOTTEST_SALE} type={type} color={'red'} />;
};

export default HottestSaleFilter;
